import React, { useState, useRef } from 'react';
import Webcam from 'react-webcam';
import { useDispatch } from 'react-redux';
import { setImage } from '../redux-store/slices/usersData.js';
import useWindowSize from '../utilities/useWindowSize.js';

const CameraPopup = ({ show, handleClose }) => {
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const dispatch = useDispatch();

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    dispatch(setImage(imageSrc));
    handleClose();
  };

  const size = useWindowSize();
  let heightAndWidth;

  if (size.width < 768) {
    heightAndWidth = 240; // Mobile
  } else if (size.width >= 768 && size.width < 1400) {
    heightAndWidth = 360; // Tablet
  } else {
    heightAndWidth = 480; // Desktop
  }

  return (
    <>
      {show && (
        <div className="h-screen flex items-center justify-center bg-blue bg-opacity-50 border-4 border-blue-600" style={{ zIndex: 9999 }}>
          <div className={`bg-white rounded-lg p-5 border-4 border-blue-600 shadow-lg ${size.width < 768 ? 'w-11/12' : size.width < 1400 ? 'w-3/4' : 'w-1/2'}`}>
            <h2 className="text-xl font-bold mb-4">Take a Photo</h2>
            <div className="flex justify-center mb-4">
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={heightAndWidth}
                height={heightAndWidth}
                videoConstraints={{
                  width: heightAndWidth,
                  height: heightAndWidth,
                  facingMode: 'user',
                }}
              />
            </div>
            <div className="flex justify-between mt-4">
              <button
                className="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2.5 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                onClick={handleClose}
              >
                Close
              </button>
             
              <button
               className="text-white bg-purple-700 hover:bg-purple-800 focus:outline-none focus:ring-4 focus:ring-purple-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900"
                onClick={capture}
              >
                Capture
              </button>
            </div>

          </div>
        </div>
      )}
      {/* {imageSrc && (
        <div>
          <h2>Captured Image:</h2>
          <img src={imageSrc} alt="Captured" />
        </div>
      )} */}
    </>
  );
};

export default CameraPopup;
